// extracted by mini-css-extract-plugin
module.exports = {"button":"Buttons_button__qYN03","primaryButton":"Buttons_primaryButton__7N3x3","brandButton":"Buttons_brandButton__cCp9d","secondaryButton":"Buttons_secondaryButton__ruBI_"};